import { api } from '../api';
import { useMutation, UseMutationResult } from 'react-query';
import queryClient from '../query-client';
import { AxiosError } from 'axios';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';

export type UpdateNoteFields = {
    rawMessage: string;
    structuredMessage?: { [key: string]: unknown };
};

export type UpdateNoteRequest = {
    id: string;
    fields: UpdateNoteFields;
};

async function updateNote(request: UpdateNoteRequest): Promise<void> {
    const { data } = await api.patch(`/notes/${request.id}`, request);
    return data;
}

export function useUpdateNote(): UseMutationResult<void, AxiosError, UpdateNoteRequest, unknown> {
    const { id: workpaperId } = useWorkpaperContext();
    return useMutation((req) => updateNote(req), {
        onSettled: () => {
            queryClient.invalidateQueries(['workpapers', workpaperId, 'procedures']);
        },
    });
}
